<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" title="Uvoz garancijskih zahtevkov" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<CRow v-if="updateSuccess !== true">
			<CCol>
				<CRow>
					<CCol>
						<CSelect
							class="pt-1"
							prepend="Način uvoza:"
							:options="importOptions"
							:value.sync="selectedImportOption"
							custom
						/>
					</CCol>
				</CRow>
				<CRow>
					<CCol>
						<b-form-file
							v-model="warrantyClaimsUploadFiles"
							:placeholder="uploadPlaceholder"
							drop-placeholder="Povleci datoteko..."
							browse-text="Brskaj"
							@input="uploadWarrantyClaimFile"
							accept=".xls, .xlsx"
							multiple/>
					</CCol>
				</CRow>
			</CCol>
		</CRow>
		<CRow v-if="updateSuccess">
			<CCol>
				<b-card>
					<CRow>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število ustvarjenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numCreatedItems }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število posodobljenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numUpdatedItems }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol v-if="totalProcessed > 0" class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število procesiranih</CCardHeader>
								<CCardBody><span class="display-3">{{ totalProcessed }}</span></CCardBody>
							</CCard>
						</CCol>
					</CRow>
				</b-card>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button v-if="updateSuccess !== true" :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onCancelModal()">Prekliči</b-button>
						<b-button :disabled="okButtonDisabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import settings from '@/settings.js';
const PH_TEXT = 'Izberi ali povleci datoteko ...';
const MAX_FILE_SIZE = 10485760;
import {
	WARRANTY_CLAIMS_IMPORT,
} from "@/store/actions/warrantyClaims";

export default {
	name: 'warranty-claims-import-modal',
	components: {
	},
	props: {
	},
	methods: {
		showModal: function () {
			this.selectedImportOption = this.importOptions[0].value;
			this.$refs.modal.show();
		},
		onOkModal: function () {
			if (this.updateSuccess === true) {
				this.$refs.modal.hide();
				this.clearModalData();
			} else {
				this.uploadFile(this, this.warrantyClaimsUploadFiles);
			}
		},
		onCancelModal: function () {
			this.$refs.modal.hide();
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Posodobi',
				progress: false,
				disabled: true
			};
			this.showAlert();
			this.numCreatedItems = 0;
			this.numUpdatedItems = 0;
			this.totalProcessed = 0;
			this.warrantyClaimsUploadFiles = null;
			if (this.updateSuccess) this.$emit('emit_warrantyClaimsImportSuccess');
			this.updateSuccess = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		uploadWarrantyClaimFile: function () {
			for (const attachment of this.warrantyClaimsUploadFiles) {
				if (attachment.size > MAX_FILE_SIZE) {
					this.showError(`Datoteka ${attachment.name} je prevelika!`);
					return;
				}
			}
		},
		uploadFile: function (ctx, files) {
			const formData = new FormData();
			files.forEach(file => {
				formData.append('files[]', file);
			});
			formData.append('importType', this.selectedImportOption);
			this.startProgress();
			this.$store.dispatch(WARRANTY_CLAIMS_IMPORT, formData)
				.then((responseData) => {
					this.stopProgress();
					this.numCreatedItems = responseData.statistics.created;
					this.numUpdatedItems = responseData.statistics.updated;
					this.totalProcessed = responseData.statistics.total_processed;
					this.updateSuccess = true;
					this.okButton.label = 'Končaj';
					this.showAlert();
				})
				.catch(error => {
					this.stopProgress();
					this.updateSuccess = false;
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						if (error.response.data.usermsg) {
							this.showAlert(error.response.data.usermsg, this.ALERT_TYPE_ERROR);
							return;
						}
						this.showAlert('Napaka pri uvozu datoteke! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
	},
	data: function () {
		return {
			settings,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Uvozi',
				progress: false,
				disabled: true
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			warrantyClaimsUploadFiles: null,
			numCreatedItems: 0,
			numUpdatedItems: 0,
			totalProcessed: 0,
			updateSuccess: null,
			importOptions: [
				{ label: 'Garancijski zahtevki', value: 'main' },
				{ label: 'Knjižbe', value: 'knjizbe' }
			],
			selectedImportOption: null
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			if (this.updateSuccess > 0) return 'xl';
			return 'md';
		},
		uploadPlaceholder () {
			return PH_TEXT;
		},
		okButtonDisabled () {
			if (this.okButton.disabled && !this.warrantyClaimsUploadFiles) {
				return true;
			}
			return false;
		}
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
.numberCardHeader {
	min-height: 5.5rem;
}
.alert {
	margin-top: 1rem;
	margin-bottom: 0;
}
</style>
<style>
.tdCatalogNumber {
	width: 10rem;
	min-width: 10rem;
	text-align: center;
}
.tdNote {
	width: 5rem;
	min-width: 5rem;
	text-align: center;
}
.tdLocation {
	width: 9rem;
	min-width: 9rem;
	text-align: center;
}
.tdActions {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
	text-align: center;
}
</style>